<template>
  <div class="clienttwo">
    <p class="ma-10">Client two will be added later.</p>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "clienttwo",
  components: {}
};
</script>
